export default __webpack_public_path__ + "static/media/2751.f09cf8a1.svg";